// removed by extract-text-webpack-plugin
module.exports = {"root":"PasswordRecoveryForm__root__2yAF2","email":"PasswordRecoveryForm__email__3qOca","bottomWrapper":"PasswordRecoveryForm__bottomWrapper__2Xsjj","bottomWrapperText":"PasswordRecoveryForm__bottomWrapperText__du_ty","modalHelperLink":"PasswordRecoveryForm__modalHelperLink__1mq5J","modalHelperText":"PasswordRecoveryForm__modalHelperText__18pcL"};


//////////////////
// WEBPACK FOOTER
// ./src/forms/PasswordRecoveryForm/PasswordRecoveryForm.css
// module id = 1725
// module chunks = 0